import React from 'react';
import Header from "../../../../components/layout/headers/Header";
import Sidebar from '../../../../components/layout/navigation/sidebar/DynamicSidebar';
import AllCooperateReceiptsTable from './AllCooperateReceiptsTable';

const AllCorporateReceipts = () => {
    return (
        <>
            <Header />
            <Sidebar />
            <div className="content-body">
                <div className="w-full px-4">
                    <AllCooperateReceiptsTable />
                </div>
            </div>
        </>
    );
}

export default AllCorporateReceipts;